module.exports = __webpack_public_path__ + "static/media/box-icon.9adae933.svg";